import * as actionTypes from "../actions/actionTypes";

//
// For saved for later success just update status to saved and dispatch event in under review compoent to fire call to get new active
//
export const denial = (state = {}, action) => {
    let nextState = {};

    switch (action.type) {
        case actionTypes.DENIAL_REASONS:
        case actionTypes.DENIAL_REASONS_FAILURE:
            nextState.processing = true;
            break;

        case actionTypes.DENIAL_REASONS_SUCCESS:
            nextState = action.response;
            nextState.processing = false;
            break;

        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};
